import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  Inject,
  Input,
} from "@angular/core";
import {
  WizardStep,
  Checklist,
  FileDoc,
  FileUploadService,
  AgNumberCountComponent,
  AgActionCellRendererComponent,
} from "../../core/components";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";
// import { TreeviewItem } from 'ngx-treeview';
import { GLOBAL } from "src/app/app.globals";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "src/app/core/services";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal,
} from "@ng-bootstrap/ng-bootstrap";
import { AgActionsComponent } from "../helper";
import { async } from "q";
import { ApiCallService } from "src/app/service/api-call.service";
import { GrievanceService } from "src/app/grievance-management/grievance.service";
import { LocalStorageService } from "src/app/service/local-storage.service";
import { DataShareService } from "src/app/service/data-share.service";
import { GatePassRequestsService } from "src/app/labour/gate-pass-requests/gate-pass-requests.service";
import * as moment from "moment";
import { GridOptions } from "ag-grid-community";
import { LogHelperService } from "src/app/core/services/log-helper.service";

@Component({
  selector: "app-sub-grievance",
  templateUrl: "./sub-grievance.component.html",
  styleUrls: ["./sub-grievance.component.css"],
})
export class SubGrievanceComponent implements OnInit {
  actiondetail: string;
  resolveddate: any;
  formChangesSubscription: Subscription;
  @ViewChild("grievanceForm") grievanceForm: NgForm;
  @Input() editData: any;

  public allowedFileTypes: any = GLOBAL.ALLOWED_FILE_TYPES;
  public maxSizeAllowed: any = "";
  checkList: Checklist[] = [];
  uploadedFiles: FileDoc[] = [];
  copyUploadedFiles: FileDoc[] = [];
  wizardSteps: WizardStep[] = [];
  contractorType = 1;
  contractorData: any;
  roleCode: any;
  selectedPlant: any;
  selectedCategory: any;
  selectedImpact: any;
  selectedPriority: any;
  selectedMode: any;
  selectedContractor: any;
  selectedSubContractor: any;
  subContractorData: any;
  masterData: any;
  globalSettings: any;
  gridApi: any;
  gridColumnApi: any;
  impactData: any;
  plantInvalid: false;
  priorityData: any;
  ConCode: any;
  plants = [];
  imagesrc: any;
  statuses: any;
  errexpecteddate: boolean;
  expecteddate;
  actionData = [];
  laboursData = [];
  per;
  actionstatus;
  filter = 0;
  userEmail = "rajnish.mehat@bolr.co.in";
  userId = 653;
  userRoleCode = 101;
  date: Date;
  dates: Date;
  categoryData: any;
  closeResult: string;
  rowData = [];
  rowData1 = [];
  defaultColDef;
  acctions = [];
  labourWorkData: any;
  getEcData: any;
  rowSelection;
  data;
  workOrder;
  documentTypes: [];
  reqLevelCode: any;
  requestTypeCode: any;
  ediGrievanceCode: string;
  // editorContent: string = "";
  editGrievanceData: any = [];
  deletedLabour: any = [];
  workOrderData: any = [];

  columnDefs = [
    {
      headerName: "Select All",
      field: "selected",
      width: 200,
      headerComponentParams: { enableSorting: false },
      suppressMenu: true,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      headerName: "#",
      field: "sortCode",
      width: 100,
      headerComponentParams: { enableSorting: false },
      suppressMenu: true,
      cellRendrer: AgNumberCountComponent,
    },
    {
      headerName: "Code",
      field: "GatePassNo",
      width: 300,
      filterParams: { applyButton: true, clearButton: true },
      suppressMenu: true,
    },
    {
      headerName: "App. No",
      field: "Request_Code",
      width: 200,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Name ",
      field: "NameInIdentity",
      width: 300,
      filterParams: { applyButton: true, clearButton: true },
      suppressMenu: true,
    },
  ];

  columnDef = [
    {
      headerName: "#",
      field: "sortCode",
      width: 40,
      headerComponentParams: { enableSorting: false },
      suppressMenu: true,
      cellRendrer: AgNumberCountComponent,
    },
    {
      headerName: "Code",
      field: "GatePassNo",
      width: 100,
      filterParams: { applyButton: true, clearButton: true },
      suppressMenu: true,
    },
    {
      headerName: "App. No",
      field: "Request_Code",
      width: 100,
      filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: "Name",
      field: "NameInIdentity",
      width: 200,
      filterParams: { applyButton: true, clearButton: true },
      suppressMenu: true,
    },
    {
      headerName: "Action",
      field: "",
      width: 100,
      headerComponentParams: { enableSorting: false },
      cellRendrer: AgActionsComponent,
    },
  ];
  modeOfCompliantData: any;
  // grivanceCode: any;
  editMode = false;
  ediGrievanceData: any;
  selectedSubContract: any
  disableAddContactPerson: boolean;
  disableAddContactState: boolean;
  constructor(
    private grievanceService: GrievanceService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    public sharedService: SharedService,
    private localStorage: LocalStorageService,
    private logHelperService: LogHelperService,
    private gatePassApi: GatePassRequestsService,
    private fileUploadService: FileUploadService,
    private dataShareService: DataShareService,
    private activatedRoute: ActivatedRoute,
    private apiCall: ApiCallService,
    private router: Router
  ) {
    this.date = new Date();
    this.dates = new Date();
    this.defaultColDef = {
      width: 100,
      resizable: true,
    };
    this.rowSelection = `multiple`;
  }

  async ngOnInit() {
    this.roleCode = JSON.parse(
      this.localStorage.getLocalStorage({ key: "Role" })
    )[0].Role_Code;
    this.masterData = this.dataShareService.masterDataArrayDataShareService;
    this.globalSettings =
      this.dataShareService.globalCodesArrayDataShareService;
    this.maxSizeAllowed =
      Number(
        this.globalSettings.find((item) => item.Code === "DOCSIZEL1").Value
      ) * 1024;
    this.allowedFileTypes = this.globalSettings.find(
      (item) => item.Code === "DOCFORMATL1"
    ).Value;

    this.formChangesSubscription =
      this.grievanceForm.form.valueChanges.subscribe((form: any) => {
        if (form["category"] === "") {
          form["category"] = null;
        }
        if (form["Contractor"] === "") {
          form["Contractor"] = null;
        }
        if (form["subContractor"] === "") {
          form["subContractor"] = null;
        }
        if (form["mode"] === "") {
          form["mode"] = null;
        }
        if (form["plant"] === "") {
          form["plant"] = null;
        }
        if (form["priority"] === "") {
          form["priority"] = null;
        }
        if (form["impact1"] === "") {
          form["impact1"] = null;
        }
      });

    this.dates = new Date();
    this.dates.setDate(this.dates.getDate() + 2);
    // this.grievanceService.getGrievanceCode().subscribe((data: any) => {
    //   this.grivanceCode = data;
    // });

    // this.apiCall.getDocumentTypes().subscribe((docTypes: []) => {
    //   this.documentTypes = docTypes;
    //   console.log(this.documentTypes)
    // });
    this.impactData = this.masterData.filter(
      (list) => list.Parent_Code === 430
    );
    if (this.impactData.length === 1) {
      this.selectedImpact = this.impactData[0].MasterItem_Code;
    }
    this.priorityData = this.masterData.filter(
      (list) => list.Parent_Code === 430
    );
    if (this.priorityData.length === 1) {
      this.selectedPriority = this.priorityData[0].MasterItem_Code;
    }
    this.categoryData = this.masterData.filter(
      (list) => list.Parent_Code === 540
    );
    if (this.categoryData.length === 1) {
      this.selectedCategory = this.categoryData[0].MasterItem_Code;
    }
    this.modeOfCompliantData = this.masterData.filter(
      (list) => list.Parent_Code === 834
    );
    if (this.modeOfCompliantData.length === 1) {
      this.selectedMode = this.modeOfCompliantData[0].MasterItem_Code;
    }

    // this.grievanceService.getMasterItemData().subscribe((masterList: any) => {
    // });
    this.getContractorList(this.contractorType);
    this.wizardPage();
    this.checklistPage();
    this.getPlants();
    this.getDocumentTypes();
    this.grivanceData();
    this.getStageLevel();

    this.ediGrievanceCode = this.editData;
    if (this.ediGrievanceCode) {
      this.editMode = true;
      const reqObj = {
        Filter: {
          Grievance_Code: this.editData.Grievance_Code,
          Action: 0, // Default value 0
          RequestType: 0, // Default value 0
          RequestedUserID: GLOBAL.USER_ID, // Logged in UserID
        },
      };

      this.grievanceService.editGrievance(reqObj).subscribe((response: any) => {
        this.editGrievanceData = response;
        const data = response.Table1[0];
        this.selectedSubContract = response.Table1[0].SubContactorVendor_Code;
        const data1 = response.Table2[0];
        this.rowData1 = response.Table3; // Selected Labour Data

        this.getWorkOrder(data.ContactorVendor_Code);
        this.selectedPlant = data.Plant_Code;
        this.getWorkOrderBySubContractors(
          data.ContactorVendor_Code,
          data.WorkOrder_Code
        );

        const reqObj = {
          ContractorVendor_Code: data.ContactorVendor_Code,
          WorkOrder_Code: data.WorkOrder_Code,
          License_Code: null,
          EcPolicy_Code: null,
          SubContractorVendor_Code: null,
          SubWorkOrder_Code: null,
          SubLicense_Code: null,
          Action: 0,
          RequreType: 0,
          RequestedUserID: GLOBAL.USER_ID,
        };

        this.grievanceService
          .getLabourByContractorWorkOrder(reqObj)
          .subscribe((data: any) => {
            this.labourWorkData = data;
            this.rowData = data; // All Labour List
            const selectedLabourCodes = new Set(
              (response.Table3 || []).map((item) => Number(item.Labour_Code))
            );

            this.rowData1 = data
              .map((labour: any) => ({
                ...labour,
                selected: selectedLabourCodes.has(Number(labour.Labour_Code))
                  ? true
                  : false,
              }))
              .filter((labour: any) => labour.selected); // Show only selected
          });

        const grivance = data;
        if (!grivance) return;

        this.ediGrievanceData = grivance;
        if (this.grievanceForm) {
          this.grievanceForm.controls["grievanceCode"].setValue(
            grivance.Grievance_Code
          );
          this.grievanceForm.controls["grievanceSubject"].setValue(
            grivance.GrievanceSubject
          );
          this.grievanceForm.controls["category"].setValue(
            grivance.GrievanceCategory
          );
          this.grievanceForm.controls["grievanceDate"].setValue(
            grivance.GrievancDate
          );
          this.grievanceForm.controls["dateOfEntry"].setValue(
            grivance.DateofEntry
          );
          this.grievanceForm.controls["personemail"].setValue(grivance.EmailId);
          this.grievanceForm.controls["Contractor"].setValue(
            grivance.ContactorVendor_Code
          );
          this.grievanceForm.controls["subContractor"].setValue(
            grivance.SubContractorVendor_Code
          );
          this.grievanceForm.controls["nameOfCompliant"].setValue(
            grivance.NameOfComplainant
          );
          this.grievanceForm.controls["mobileNo"].setValue(grivance.Mobile);
          this.grievanceForm.controls["phoneNo"].setValue(grivance.PhoneNumber);
          this.grievanceForm.controls["impact"].setValue(
            grivance.WorkOrder_Code
          );
          this.grievanceForm.controls["impact1"].setValue(grivance.Impact);
          this.grievanceForm.controls["priority"].setValue(grivance.Priority);
          this.grievanceForm.controls["mode"].setValue(grivance.ModeOfComplian);
          this.grievanceForm.controls["editorText"].setValue(
            grivance.Description
          );
          this.grievanceForm.controls["plant"].setValue(grivance.Plant_Code);
          // this.grievanceForm.controls['description1'].setValue(grivance.Description);
          this.grievanceForm.controls["expectedDate"].setValue(
            grivance.ExpectedDate
          );
          this.grievanceForm.controls["status1"].setValue(
            data1.StatusMasterItem
          );
          this.grievanceForm.controls["actionDetail"].setValue(
            data1.ActionDetail
          );
          this.grievanceForm.controls["closeDate"].setValue(grivance.CloseDate);
        }
        // this.grievanceForm.controls['closeDate'].setValue(grivance.PermentDistrict_Code);
      });
    } else {
      this.editMode = false;
    }

    this.checklistPage();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    setTimeout(() => {
      this.selectPreSelectedRows();
    }, 100);
  }

  gridOptions: GridOptions = {
    animateRows: true,
    rowSelection: "multiple",
    rowHeight: 40,
    headerHeight: 40,
    pagination: false,
  };

  selectPreSelectedRows() {
    if (!this.gridApi) return;

    this.gridApi.forEachNode((node: any) => {
      if (
        this.rowData1.some(
          (labour: any) => labour.Labour_Code === node.data.Labour_Code
        )
      ) {
        node.setSelected(true);
      }
    });
  }
  getDocumentTypes() {
    const res = {
      Page_Code: 202,
      RequireType: 1,
      ActionType: 0,
      UserId: GLOBAL.USER_ID,
      Search: null,
      SelectedField: "Name,DocumentType_Code,page_code",
    };
    this.gatePassApi
      .getDocumentTypesPageModuleWise(res)
      .subscribe((docTypes: any) => {
        this.documentTypes = docTypes;
      });
  }

  getStageLevel() {
    const res = {
      Filter: {
        RequestType_Code: "108",
        UserID: GLOBAL.USER_ID,
      },
      Fields: [
        {
          KeyName: "RequestType_Code",
          DisplayName: "RequestType",
        },
        {
          keyName: "Plant_Code",
          DisplayName: "Plant",
        },
        {
          keyName: "Priority",
          DisplayName: "PriorityN",
        },
        {
          keyName: "Role_Code",
          DisplayName: "Role",
          ExtraFields: [
            "RequestLevel_Code",
            "Level",
            "Module_Code",
            "Module_Name",
            "IsActive",
            "IsDelete",
            "IsLastLevel",
          ],
        },
      ],
    };
    this.gatePassApi.getRequestStageLevel(res).subscribe((docTypes: any) => {
      const extractRoles = (data: any) => {
        let roles: {
          RequestType_Code: number;
          Role_Code: number;
          Role: string;
          RequestLevel_Code: number;
        }[] = [];

        data.forEach((item: any) => {
          item.Values.forEach((plant: any) => {
            plant.Values.forEach((priority: any) => {
              priority.Values.forEach((roleItem: any) => {
                roles.push({
                  RequestType_Code: item.RequestType_Code,
                  Role_Code: roleItem.Role_Code,
                  Role: roleItem.Role,
                  RequestLevel_Code: roleItem.RequestLevel_Code,
                });
              });
            });
          });
        });

        return roles;
      };

      const extractedRoles = extractRoles(docTypes);
      const getRequestLevelCode = () => {
        const matchedRole = extractedRoles.find(
          (role) => role.Role_Code === GLOBAL.ROLE_CODE
        );
        return matchedRole ? matchedRole.RequestLevel_Code : null;
      };
      const getRequestTypeCode = () => {
        const matchedRole = extractedRoles.find(
          (role) => role.Role_Code === GLOBAL.ROLE_CODE
        );
        return matchedRole ? matchedRole.RequestType_Code : null;
      };

      const matchedRequestLevelCode = getRequestLevelCode();
      const matchedRequestTypeCode = getRequestTypeCode();

      this.reqLevelCode = matchedRequestLevelCode;
      this.requestTypeCode = matchedRequestTypeCode;
    });
  }

  onFilesChanged(newFiles: any) {
    const set = new Set(
      newFiles.filter((item) => {
        if (item.ID) {
          return item.ID;
        }
      })
    );
    const result = [];

    for (const item of this.copyUploadedFiles) {
      if (!set.has(item.ID)) {
        result.push(item);
      }
    }
  }
  onSelectionChanged(params) {
    this.data = params.api.getSelectedRows();
    this.laboursData = this.data.map((item) => ({
      ID: null,
      Grievance_Code: null,
      ContractorVendor_Code: item.ContractorVendor_Code,
      WorkOrder_Code: item.WorkOrder_Code,
      Labour_Code: item.Labour_Code,
      CreateBy: GLOBAL.USER_ID,
      ModifiedBy: GLOBAL.USER_ID,
      IsActive: 1,
      IsDelete: 0,
    }));
  }

  addLabour1(event) {
    this.rowData1 = this.data;
  }

  ststusData: any[] = []
  addStatus() {
    let obj = {
      expectedDate: moment(this.dates).format("DD-MM-YYYY"),
      status: this.grievanceForm.value.status1,
      actionDetail: this.grievanceForm.value.actionDetail,
      closeDate: moment(this.grievanceForm.value.closeDate).format("DD-MM-YYYY"),
    }
    this.ststusData.push(obj)
  }

  clearAll() {
    this.rowData1 = [];
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  onRowClick(event) {
    this.rowSelection = "multiple";
  }

  // onTrixChange(event: any) {
  //   this.editorContent = event.target.value;
  //   console.log('Trix Editor Content:', this.editorContent);
  // }

  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", size: "lg" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    }
    if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    }
  }

  getContractorList(contractorType: number) {
    this.grievanceService
      .getAllContractors(contractorType)
      .subscribe((res: any) => {
        this.contractorData = res.Data.Table || [];
        if (this.contractorData.length === 1) {
          this.selectedContractor = res.Data.Table[0].ContractorVendor_Code;
        }
      });
  }

  onContractorChange(event) {
    this.ConCode = event.ContractorVendor_Code;
    this.grievanceForm.controls["impact"].setValue(null);
    this.getWorkOrder(this.ConCode);
  }
  getWorkOrder(contractor) {
    this.apiCall.getWorkOrdersByContractorCode(contractor, this.selectedPlant).subscribe((response: any) => {
      this.workOrderData = response;
      if (response.length === 1) {
        this.grievanceForm.controls["impact"].setValue(null); this.grievanceForm.controls["impact"].setValue(response[0].WorkOrder_Code);
      }
    });
  }

  getWorkOrderBySubContractors(contractor, workOrder): void {
    const params = {
      isMain: "0",
      Contractor_Code: contractor,
      workOrderCode: workOrder,
      UserID: GLOBAL.USER_ID,
    };
    this.apiCall.getSubContractors(params).subscribe((response) => {
      this.subContractorData = response;
      if (this.subContractorData.length === 1) {
        this.selectedSubContractor = response[0].ContractorVendor_Code;
      }
      response.forEach((data) => {
        if (data.ContractorVendor_Code == this.selectedSubContract) {
          this.grievanceForm.controls["subContractor"].setValue(data.ContractorVendor_Code);
        }
      })

    });
  }

  grivanceData() {
    const reqObj = {
      Filter: {
        ShortCode: "GM245,GM246",
        Parent_Code: null,
        Search: null, //"Document",
        Page_Code: 202,
        RequireType: 1, //0: Full master datawith parent info (Only @search applicable) | 1: Short code wise list find | 2: Page, parent code & role wise data | 3: Page and Parent code , Role is not required
        ActionType: 0,
        UserId: GLOBAL.USER_ID,
      },
      Fields: [
        {
          keyName: "Parent_Code",
          DisplayName: "ParentName",
        },
        {
          keyName: "MasterItem_Code",
          DisplayName: "Name",
          ExtraFields: [
            "Pincode_Code",
            "ZipCode",
            "ShortName",
            "ShortCode",
            "Page_Code",
            "Module_Code",
            "MouleName",
            "AppsGroups_Code",
            "AppGroupName",
            "IsDelete",
            "IsActive",
          ],
        },
      ],
    };
    this.apiCall.getGrievanceData(reqObj).subscribe((data: any) => {
      this.statuses = data.flatMap((group) =>
        group.Values.map((item) => ({
          ...item,
          category: group.ParentName,
        }))
      );
    });
  }

  getlabourByWorkOrder(event) {
    const reqObj = {
      ContractorVendor_Code: this.ConCode, // Not null
      WorkOrder_Code: event.WorkOrder_Code, // Not null
      License_Code: null,
      EcPolicy_Code: null,
      SubContractorVendor_Code: null,
      SubWorkOrder_Code: null,
      SubLicense_Code: null,
      Action: 0,
      RequreType: 0,
      RequestedUserID: GLOBAL.USER_ID,
    };
    this.grievanceService
      .getLabourByContractorWorkOrder(reqObj)
      .subscribe((data: any) => {
        this.labourWorkData = data;
        this.rowData = data;
      });
  }

  getEICUserByWorkorer(event) {
    this.grievanceService
      .getEICUserByWorkorer(event.WorkOrder_Code)
      .subscribe((data: any) => {
        this.workOrder = event.WorkOrder_Code;
        this.getEcData = data;
      });
  }
  uploadDocuments() {
    if (this.uploadedFiles.length) {
      const DocumentImageMasterViewModals: any = [];
      this.uploadedFiles.forEach((file) => {
        if (file.isUploaded) {
          DocumentImageMasterViewModals.push({
            ID: file.ID,
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        } else {
          DocumentImageMasterViewModals.push({
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        }
      });
    }
    // if (this.uploadedFiles && this.uploadedFiles.length > 0) {
    //   if (this.selectedLabour.Labour_Code) {
    //     this.fileUploadService.uploadFiles(
    //       this.uploadedFiles,
    //       this.selectedLabour,
    //       GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_DOC
    //     ).subscribe((res) => { });
    //   }
    // }
  }

  deleteContractor(index: number) {
    this.rowData1.splice(index, 1);
    this.deletedLabour.push(this.rowData1[index]);
    this.laboursData.splice(index, 1);
  }

  deleteStatus(index: number) {
    this.ststusData.splice(index, 1);
  }

  /**
   * GET plant REQUEST
   * @author Sonal Prajapati
   */
  getPlants() {
    this.grievanceService.getPlants().subscribe((data: any) => {
      this.plants = data;
      if (this.plants.length === 1) {
        this.selectedPlant = this.plants[0].Plant_Code;
      }
    });
  }

  wizardPage() {
    this.wizardSteps = [
      {
        id: "grievance",
        name: "Grievance Information",
        isValid: () => {
          return (
            this.grievanceForm.controls.grievanceSubject.valid &&
            this.grievanceForm.controls.Contractor.valid &&
            this.grievanceForm.controls.nameOfCompliant.valid &&
            this.grievanceForm.controls.mobileNo.valid
          );
        },
      },
      {
        id: "Labour",
        name: "Labour",
        isValid: () => {
          return true;
        },
      },
      {
        id: "Document",
        name: "Document",
        isValid: () => {
          return true;
        },
      },
    ];
    if (this.roleCode !== 119) {
      this.wizardSteps.push({
        id: "CourseActionTaken",
        name: "CourseActionTaken",
        isValid: () => {
          return true;
        },
      });
    }
  }

  checklistPage() {
    this.checkList = [
      {
        id: 1,
        text: "Grievance Details",
        open: true,
        childrens: [
          {
            text: "Grievance Details",
            title: "Grievance Details",
            desc: " Grievance Subject, Grievance Category, Grievance Date, Name of Complainant, Mobile Are Must Required.",
            isValid: () => {
              return (
                this.grievanceForm.controls.grievanceSubject.valid &&
                this.grievanceForm.controls.category.valid &&
                this.grievanceForm.controls.grievanceDate.valid &&
                this.grievanceForm.controls.nameOfCompliant.valid &&
                this.grievanceForm.controls.mobileNo.valid
              );
            },
            hasError: () => {
              return (
                (this.grievanceForm.controls.grievanceSubject.dirty ||
                  this.grievanceForm.controls.grievanceSubject.touched ||
                  this.grievanceForm.controls.category.dirty ||
                  this.grievanceForm.controls.category.touched ||
                  this.grievanceForm.controls.grievanceDate.dirty ||
                  this.grievanceForm.controls.grievanceDate.touched ||
                  this.grievanceForm.controls.nameOfCompliant.dirty ||
                  this.grievanceForm.controls.nameOfCompliant.touched ||
                  this.grievanceForm.controls.mobileNo.dirty ||
                  this.grievanceForm.controls.mobileNo.touched) &&
                (this.grievanceForm.controls.grievanceSubject.invalid ||
                  this.grievanceForm.controls.category.invalid ||
                  this.grievanceForm.controls.grievanceDate.invalid ||
                  this.grievanceForm.controls.nameOfCompliant.invalid ||
                  this.grievanceForm.controls.mobileNo.invalid)
              );
            },
            isMandatory: true,
            isVisible: true,
            step: "1",
          },
          {
            text: "Company Details",
            title: "CompanyInfo",
            desc: "Plant must be Required.",
            isValid: () => {
              return this.grievanceForm.controls.plant.valid;
            },
            hasError: () => {
              return (
                (this.grievanceForm.controls.plant.dirty ||
                  this.grievanceForm.controls.plant.touched) &&
                this.grievanceForm.controls.plant.invalid
              );
            },
            isMandatory: true,
            isVisible: true,
            step: "2",
          },
          {
            text: "Status",
            title: "GrievanceStatus",
            desc: "Impact and Priority details are required.",
            isValid: () => {
              return (
                this.grievanceForm.controls.impact1.valid &&
                this.grievanceForm.controls.priority.valid
              );
            },
            hasError: () => {
              return (
                (this.grievanceForm.controls.impact1.dirty ||
                  this.grievanceForm.controls.impact1.touched ||
                  this.grievanceForm.controls.priority.dirty ||
                  this.grievanceForm.controls.priority.touched) &&
                (this.grievanceForm.controls.impact1.invalid ||
                  this.grievanceForm.controls.priority.invalid)
              );
            },
            isMandatory: true,
            isVisible: true,
            step: "3",
          },
          {
            text: "Select Contractor",
            title: "Select Contractor",
            desc: "Contractor must be Required",
            isValid: () => {
              return this.grievanceForm.controls.Contractor.valid;
            },
            hasError: () => {
              return (
                (this.grievanceForm.controls.Contractor.dirty ||
                  this.grievanceForm.controls.Contractor.touched) &&
                this.grievanceForm.controls.Contractor.invalid
              );
            },
            isMandatory: true,
            isVisible: true,
            step: "4",
          },
        ],
      },
    ];
  }

  onPlantChange(value: any) {
    this.grievanceForm.controls.plant.markAsTouched();
    this.grievanceForm.controls.plant.updateValueAndValidity();
  }

  onSubmit(grievanceForm, redirect = true) {
    const grievance = {
      ["B41E0892-A36D-4E5C-A6E6-7AE5C74F6D1B"]: {
        Grievance_Code: null,
        RequestNbr: null,
        GrievanceSubject: grievanceForm.grievanceSubject,
        GrievanceCategory: grievanceForm.category, //
        GrievancDate: moment(grievanceForm.grievanceDate).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        DateofEntry: moment(this.date).format("YYYY-MM-DD HH:mm:ss"),
        ExpectedDate: moment(this.date).format("YYYY-MM-DD HH:mm:ss"),
        Impact: grievanceForm.impact1,
        Priority: grievanceForm.priority,
        ContactorVendor_Code: grievanceForm.Contractor,
        SubContactorVendor_Code: grievanceForm.subContractor,
        WorkOrder_Code: grievanceForm.impact,
        SubWorkOrder_Code: null,
        ECPolicy_Code: null,
        License_Code: null,
        ModeOfComplian: grievanceForm.mode,
        Plant_Code: grievanceForm.plant,
        NameOfComplainant: grievanceForm.nameOfCompliant,
        Mobile: grievanceForm.mobileNo,
        EmailId: grievanceForm.personemail,
        PhoneNumber: grievanceForm.phoneNo,
        Description: grievanceForm.editorText,
        CloseDate: moment(grievanceForm.closeDate).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        CloseBy: 100,
        "47403E9B-9665-400D-BA3A-642A4D611707": {
          //GrievanceAction
          ID: null,
          Grievance_Code: null,
          ExpectedDate: moment(this.date).format("YYYY-MM-DD HH:mm:ss"),
          ActionDetail: grievanceForm.actionDetail,
          "StatusMasterItem ": grievanceForm.status1,
          ResolveDate: moment(grievanceForm.closeDate).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          //"CreatedDate": null,
          CreateBy: GLOBAL.USER_ID, // logged in user ID
          //"ModifiedDate": null,
          ModifiedBy: GLOBAL.USER_ID, // logged in user ID
          IsActive: 1,
          IsDelete: 0,
        },
        "2C2313C7-2902-4812-A530-E59355CB09A9":
          this.laboursData.length === 1
            ? this.laboursData[0]
            : this.laboursData,
        "92118B32-6C6D-4E42-B2CB-04C532AFC4EF": {
          //GrievanceRequestList
          Request_Code: null,
          Grievance_Code: null,
          RequestNo: "12345",
          RequestType_Code: 108,
          RequestDate: moment(grievanceForm.grievanceDate).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          RequestCloseDate: moment(grievanceForm.closeDate).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          FirstRequestUser: GLOBAL.USER_ID,
          IsApproved: 0,
          //"CreatedDate": null,
          CreateBy: GLOBAL.USER_ID, // logged in user ID
          //"ModifiedDate": null,
          ModifiedBy: GLOBAL.USER_ID, // logged in user ID
          IsActive: 1,
          "14790EE9-C01A-49E1-932A-D9CACA2E5715": {
            RequestApprover_Code: null,
            Request_Code: null,
            RequestLevel_Code: this.reqLevelCode,
            StatusMasterList_Code: grievanceForm.status1,
            Comment: null,
            //"CreatedDate": null,
            CreateBy: GLOBAL.USER_ID, // logged in user ID
            //"ModifiedDate": null,
            ModifiedBy: GLOBAL.USER_ID, // logged in user ID
            IsActive: 1,
            IsDelete: 0,
          },
        },
      },
    };
    const uploadParams = {
      contractorvendor_code: "",
    };

    if (this.editMode) {

      const editGrievance: any = {
        ["B41E0892-A36D-4E5C-A6E6-7AE5C74F6D1B"]: {},
      };

      const grievanceData =
        editGrievance["B41E0892-A36D-4E5C-A6E6-7AE5C74F6D1B"];

      const addFieldIfChanged = (newValue: any, oldValue: any, key?: string) => {
        const requiredKeys = [
          "Grievance_Code",
          "ID",
          "Request_Code",
          "RequestApprover_Code",
          "CreateBy",
          "ModifiedBy",
          "IsActive",
          "IsDelete",
          "IsApproved",
        ];
        if (requiredKeys.includes(key)) {
          return {
            OldValue:
              oldValue !== undefined && oldValue !== null ? oldValue : null,
            NewValue:
              newValue !== undefined && newValue !== null ? newValue : null,
          };
        }

        return newValue !== oldValue ? {
          OldValue: oldValue !== undefined && oldValue !== null ? oldValue : null,
          NewValue: newValue !== undefined && newValue !== null ? newValue : null,
        } : undefined;
      };

      const getSafeValue = (obj: any, path: string, defaultValue: any = null) => {
        return path.split(".").reduce((acc, key) => acc && acc[key] !== undefined ? acc[key] : defaultValue, obj);
      };

       
      const formatDate = (dateObj: any) => {
        if (dateObj && dateObj._isAMomentObject) {
          return moment(dateObj._i).format("YYYY-MM-DDTHH:mm:ss");
        }
        return dateObj;
      };
      

      grievanceData["ExpectedDate"] = addFieldIfChanged(
        formatDate(getSafeValue(this.editGrievanceData, "Table1.0.ExpectedDate", null)),
        getSafeValue(this.editGrievanceData, "Table1.0.ExpectedDate", null)
      );
      grievanceData["GrievancDate"] = addFieldIfChanged(
        formatDate(getSafeValue(grievanceForm, "grievanceDate", null)),
        getSafeValue(this.editGrievanceData, "Table1.0.GrievancDate", null)
      );
      grievanceData["DateofEntry"] = addFieldIfChanged(
        formatDate(getSafeValue(this.editGrievanceData, "Table1.0.DateofEntry", null)),
        getSafeValue(this.editGrievanceData, "Table1.0.DateofEntry", null)
      );
      grievanceData["Impact"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "impact1", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Impact", null)
      );
      grievanceData["Priority"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "priority", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Priority", null)
      );
      grievanceData["Grievance_Code"] = addFieldIfChanged(
        getSafeValue(this.editGrievanceData, "Table1.0.Grievance_Code", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Grievance_Code", null),
        "Grievance_Code"
      );
      grievanceData["RequestNbr"] = addFieldIfChanged(
        getSafeValue(this.editGrievanceData, "Table1.0.RequestNbr", null),
        getSafeValue(this.editGrievanceData, "Table1.0.RequestNbr", null)
      );
      grievanceData["GrievanceCategory"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "category", null),
        getSafeValue(this.editGrievanceData, "Table1.0.GrievanceCategory", null)
      );
      grievanceData["SubContactorVendor_Code"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "subContractor", null),
        getSafeValue(this.editGrievanceData, "Table1.0.SubContactorVendor_Code", null)
      );
      grievanceData["ContactorVendor_Code"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "Contractor", null),
        getSafeValue(this.editGrievanceData, "Table1.0.ContactorVendor_Code", null)
      );
      grievanceData["ModeOfComplian"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "mode", null),
        getSafeValue(this.editGrievanceData, "Table1.0.ModeOfComplian", null)
      );
      grievanceData["Plant_Code"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "plant", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Plant_Code", null)
      );
      grievanceData["NameOfComplainant"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "nameOfCompliant", null),
        getSafeValue(this.editGrievanceData, "Table1.0.NameOfComplainant", null)
      );
      grievanceData["Description"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "editorText", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Description", null)
      );
      grievanceData["Mobile"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "mobileNo", null),
        getSafeValue(this.editGrievanceData, "Table1.0.Mobile", null)
      );
      grievanceData["EmailId"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "personemail", null),
        getSafeValue(this.editGrievanceData, "Table1.0.EmailId", null)
      );
      grievanceData["PhoneNumber"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "phoneNo", null),
        getSafeValue(this.editGrievanceData, "Table1.0.PhoneNumber", null)
      );
      grievanceData["WorkOrder_Code"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "impact", null),
        getSafeValue(this.editGrievanceData, "Table1.0.WorkOrder_Code", null)
      );
      grievanceData["GrievanceSubject"] = addFieldIfChanged(
        getSafeValue(grievanceForm, "grievanceSubject", null),
        getSafeValue(this.editGrievanceData, "Table1.0.GrievanceSubject", null)
      );

      grievanceData["47403E9B-9665-400D-BA3A-642A4D611707"] = [{
        ID: addFieldIfChanged(
          getSafeValue(this.editGrievanceData, "Table2.0.ID", null),
          getSafeValue(this.editGrievanceData, "Table2.0.ID", null),
          "ID"
        ),
        Grievance_Code: addFieldIfChanged(
          getSafeValue(this.editGrievanceData, "Table2.0.Grievance_Code", null),
          getSafeValue(this.editGrievanceData, "Table2.0.Grievance_Code", null),
          "Grievance_Code"
        ),
        ResolveDate: addFieldIfChanged(
          formatDate(getSafeValue(grievanceForm, "closeDate", null)),
          getSafeValue(this.editGrievanceData, "Table2.0.ResolveDate", null)
        ),
        ExpectedDate: addFieldIfChanged(
          formatDate(getSafeValue(this.editGrievanceData, "Table2.0.ExpectedDate", null)),
          getSafeValue(this.editGrievanceData, "Table2.0.ExpectedDate", null)
        ),
        StatusMasterItem: addFieldIfChanged(
          getSafeValue(grievanceForm, "status1", null),
          getSafeValue(this.editGrievanceData, "Table2.0.StatusMasterItem", null)
        ),
        ActionDetail: addFieldIfChanged(
          getSafeValue(grievanceForm, "actionDetail", null),
          getSafeValue(this.editGrievanceData, "Table2.0.ActionDetail", null)
        ),
        CreateBy: addFieldIfChanged(GLOBAL.USER_ID, GLOBAL.USER_ID, "CreateBy"),
        ModifiedBy: addFieldIfChanged(GLOBAL.USER_ID, GLOBAL.USER_ID, "ModifiedBy"),
        IsActive: addFieldIfChanged(1, 1, "IsActive"),
        IsDelete: addFieldIfChanged(0, 0, "IsDelete"),
      }];

      grievanceData["92118B32-6C6D-4E42-B2CB-04C532AFC4EF"] = [{
        Request_Code: addFieldIfChanged(
          getSafeValue(this.editGrievanceData, "Table4.0.Request_Code", null),
          getSafeValue(this.editGrievanceData, "Table4.0.Request_Code", null),
          "Request_Code"
        ),
        Grievance_Code: addFieldIfChanged(
          getSafeValue(this.editGrievanceData, "Table4.0.Grievance_Code", null),
          getSafeValue(this.editGrievanceData, "Table4.0.Grievance_Code", null),
          "Grievance_Code"
        ),
        RequestCloseDate: addFieldIfChanged(
          formatDate(getSafeValue(grievanceForm, "closeDate", null)),
          getSafeValue(this.editGrievanceData, "Table4.0.RequestCloseDate", null)
        ),
        RequestDate: addFieldIfChanged(
          formatDate(getSafeValue(grievanceForm, "grievanceDate", null)),
          getSafeValue(this.editGrievanceData, "Table4.0.RequestDate", null)
        ),
        // FirstRequestUser: addFieldIfChanged(GLOBAL.USER_ID, GLOBAL.USER_ID),
        IsApproved: addFieldIfChanged(0, 0, "IsApproved"),
        CreateBy: addFieldIfChanged(GLOBAL.USER_ID, GLOBAL.USER_ID, "CreateBy"),
        ModifiedBy: addFieldIfChanged(
          GLOBAL.USER_ID,
          GLOBAL.USER_ID,
          "ModifiedBy"
        ),
        IsActive: addFieldIfChanged(1, 1, "IsActive"),
        // "14790EE9-C01A-49E1-932A-D9CACA2E5715": {
        //   RequestApprover_Code: addFieldIfChanged(
        //     getSafeValue(
        //       this.editGrievanceData,
        //       "Table4.0.RequestType_Code",
        //       null
        //     ),
        //     getSafeValue(
        //       this.editGrievanceData,
        //       "Table4.0.RequestType_Code",
        //       null
        //     ),
        //     "RequestApprover_Code"
        //   ),
        //   // StatusMasterList_Code: addFieldIfChanged(
        //   //   getSafeValue(grievanceForm, "status1", null),
        //   //   getSafeValue(this.editGrievanceData, "Table2.0.StatusMasterItem", null)
        //   // ),
        //   Request_Code: addFieldIfChanged(
        //     getSafeValue(this.editGrievanceData, "Table4.0.Request_Code", null),
        //     getSafeValue(this.editGrievanceData, "Table4.0.Request_Code", null),
        //     "Request_Code"
        //   ),
        //   Grievance_Code: addFieldIfChanged(
        //     getSafeValue(
        //       this.editGrievanceData,
        //       "Table4.0.Grievance_Code",
        //       null
        //     ),
        //     getSafeValue(
        //       this.editGrievanceData,
        //       "Table4.0.Grievance_Code",
        //       null
        //     ),
        //     "Grievance_Code"
        //   ),
        //   CreateBy: addFieldIfChanged(
        //     GLOBAL.USER_ID,
        //     GLOBAL.USER_ID,
        //     "CreateBy"
        //   ),
        //   ModifiedBy: addFieldIfChanged(
        //     GLOBAL.USER_ID,
        //     GLOBAL.USER_ID,
        //     "ModifiedBy"
        //   ),
        //   IsActive: addFieldIfChanged(1, 1, "IsActive"),
        //   IsDelete: addFieldIfChanged(0, 0, "IsDelete"),
        // },
      }];

      const labourCodes = this.editGrievanceData.Table3.map(item => item.Labour_Code);
      const dataLabourCodes = this.rowData1.map(item => item.Labour_Code);

      const labourCodesSet = new Set(labourCodes);
      const dataLabourCodesSet = new Set(dataLabourCodes);

      const missingInLaboursData = labourCodes.filter(code => !dataLabourCodesSet.has(code));
      const missingInEditGrievanceData = dataLabourCodes.filter(code => !labourCodesSet.has(code));

      const matchedDataFromRowData1 = this.laboursData.filter(data =>
        missingInEditGrievanceData.includes(data.Labour_Code)
      );

      const notMatchedData = this.editGrievanceData.Table3.filter(data =>
        missingInLaboursData.includes(data.Labour_Code)
      );

      const formattedNotMatchedData = notMatchedData.map(data => ({
        Grievance_Code: {
          OldValue: data.Grievance_Code,
          NewValue: data.Grievance_Code
        },
        ID: {
          OldValue: data.ID,
          NewValue: data.ID
        },
       
        IsDelete: {
          OldValue: 0,
          NewValue: 1
        }
      }));

      const combinedData = formattedNotMatchedData.concat(matchedDataFromRowData1);
      grievanceData["2C2313C7-2902-4812-A530-E59355CB09A9"] = combinedData;

      const cleanDeep = (obj: any): any => {
        if (Array.isArray(obj)) {
          return obj
            .map(cleanDeep)
            .filter(
              (item) =>
                item !== undefined &&
                item !== null &&
                !(typeof item === "object" && Object.keys(item).length === 0)
            );
        } else if (typeof obj === "object" && obj !== null) {
          const cleanedObj = Object.entries(obj).reduce((acc, [key, value]) => {
            const cleanedValue = cleanDeep(value);
      
            if (
              cleanedValue !== undefined &&
              cleanedValue !== null &&
              !(
                typeof cleanedValue === "object" &&
                Object.keys(cleanedValue).length === 0
              ) &&
              !(
                key !== "Grievance_Code" &&
                key !== "ID" &&
                key !== "Request_Code" &&
                key !== "RequestApprover_Code" &&
                key !== "CreateBy" &&
                key !== "ModifiedBy" &&
                key !== "IsActive" &&
                key !== "IsDelete" &&
                key !== "IsApproved" &&
                cleanedValue.hasOwnProperty("oldValue") &&
                cleanedValue.hasOwnProperty("newValue") &&
                (cleanedValue.oldValue === null || cleanedValue.oldValue === undefined) &&
                (cleanedValue.newValue === null || cleanedValue.newValue === undefined)
              )
            ) {
              acc[key] = cleanedValue;
            }
      
            if (key === "Grievance_Code") {
              acc[key] = value;
            }
      
            return acc;
          }, {} as any);
      
          return Object.keys(cleanedObj).length > 0 ? cleanedObj : undefined;
        }
        return obj;
      };
      

      const findKeyLength = (obj: any, keyToCheck: string): number | null => {
        if (obj && obj.hasOwnProperty(keyToCheck)) {
          const value = obj[keyToCheck];
          if (Array.isArray(value)) {
            return value.length;
          }
        }
        return null;
      };

      const removeKeysWithSmallLength = (obj: any, parentKey: string, keyToCheck: string): any => {
        if (obj && obj[parentKey]) {
          const keyLength = findKeyLength(obj[parentKey], keyToCheck);
          if (keyLength !== null && keyLength < 1) {
            delete obj[parentKey][keyToCheck];
          }
        }
        return obj;
      };

      const finalPayload = cleanDeep(editGrievance) || {};
      const updatedPayload = removeKeysWithSmallLength(finalPayload, "B41E0892-A36D-4E5C-A6E6-7AE5C74F6D1B", "2C2313C7-2902-4812-A530-E59355CB09A9");
      const parentKey = "B41E0892-A36D-4E5C-A6E6-7AE5C74F6D1B";
      const keysToCheck = ["47403E9B-9665-400D-BA3A-642A4D611707", "92118B32-6C6D-4E42-B2CB-04C532AFC4EF"];

      keysToCheck.forEach((key) => {
        if (
          updatedPayload[parentKey] &&
          updatedPayload[parentKey][key] &&
          Array.isArray(updatedPayload[parentKey][key]) && updatedPayload[parentKey][key][0]
        ) {
          const length = Object.keys(updatedPayload[parentKey][key][0]).length;
          if (length === 6) {
            delete updatedPayload[parentKey][key];
          }
        }
      });
      
      
      if (updatedPayload[parentKey]) {
        const length = Object.keys(updatedPayload[parentKey]).length;
        // if (length === 6) {
        //   delete updatedPayload[parentKey][keyToCheck];
        // }
      }

      this.fileUploadService.uploadFiles(this.uploadedFiles, 202, GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_DOC).subscribe((res) => {
      });
      if (grievanceForm.grievanceCode && grievanceForm.grievanceSubject && grievanceForm.category && grievanceForm.dateOfEntry && grievanceForm.Contractor && grievanceForm.impact && grievanceForm.subContractor && grievanceForm.nameOfCompliant && grievanceForm.mobileNo && grievanceForm.impact1 && grievanceForm.priority && grievanceForm.plant) {
        this.apiCall.apiCommonInsertUpdate(updatedPayload).subscribe((result: any) => {
          uploadParams.contractorvendor_code = result.Code;
          this.router.navigate(["grievances"]);
          this.logHelperService.logSuccess({
            message: "Grievance updated successfully"
          });
          // if (uploadParams.contractorvendor_code) {
            // }
          });
      } else {
        const missingFields = [];

        if (!grievanceForm.grievanceCode) missingFields.push("Grievance Code");
        if (!grievanceForm.grievanceSubject) missingFields.push("Grievance Subject");
        if (!grievanceForm.category) missingFields.push("Category");
        if (!grievanceForm.dateOfEntry) missingFields.push("Date of Entry");
        if (!grievanceForm.Contractor) missingFields.push("Contractor");
        if (!grievanceForm.impact) missingFields.push("Impact");
        if (!grievanceForm.subContractor) missingFields.push("Sub Contractor");
        if (!grievanceForm.nameOfCompliant) missingFields.push("Name of Complainant");
        if (!grievanceForm.mobileNo) missingFields.push("Mobile Number");
        if (!grievanceForm.impact1) missingFields.push("Impact 1");
        if (!grievanceForm.priority) missingFields.push("Priority");
        if (!grievanceForm.plant) missingFields.push("Plant");

        if (missingFields.length > 0) {
          this.logHelperService.logError({
            message: `Missing Fields: ${missingFields.join(", ")}`
          });
        }

      }
    } else {
      this.apiCall.apiCommonInsertUpdate(grievance).subscribe((result: any) => {
        uploadParams.contractorvendor_code = result.Code;
        if (uploadParams.contractorvendor_code) {
          this.fileUploadService
            .uploadFiles(
              this.uploadedFiles,
              uploadParams,
              GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_DOC
            )
            .subscribe((res) => {
              if (redirect) {
                this.router.navigate(["grievances"]);
              } else {
                this.grievanceForm.reset();
                this.clearForm();
              }
            });
        }
      });
    }
  }
  saveAndNew() {
    this.onSubmit(this.grievanceForm.value, false);
  }

  clearForm() {
    this.grievanceForm.reset();
  }

  onCancel() {
    this.grievanceForm.reset();
    this.router.navigate(["grievances"]);
    this.activeModal.close();
  }

  onCloseAction(): void {
    this.activeModal.close();
    this.grievanceForm.reset();
  }

  updateAndNew() {
    console.log("this.grievanceForm.value", this.grievanceForm.value);
    this.onSubmit(this.grievanceForm.value, false);
    this.grievanceForm.reset();
  }
}
